<template>
  <div class="card dashboard-widget rulebase-match-widget">
    <div class="card-header">RULEBASE MATCHES</div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <div class="row justify-content-center">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10">
              <GChart
                id= "rulebase-chart"
                class="g-chart"
                type="PieChart"
                :data="rulebaseMatchPieData"
                :events="chartEvents"
                :options="pieChartOptions"
              ></GChart>
              <button class="btn btn-sm btn-light float-btn pl-1"
                      v-show="focusId" @click="focusId = null">
                <i class="fas fa-caret-left"></i>
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="padding-title-left">
        Rule name
      </div>
      <div class="row">
        <div class="col-sm-12">
          <apexchart type="bar"
                     :series="seriesData"
                     :options="seriesOptions"></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { GChart } from 'vue-google-charts';

const ChartColor = [
  '#3366CC',
  '#DC3912',
  '#FF9900',
  '#109618',
  '#990099',
  '#3B3EAC',
  '#0099C6',
  '#DD4477',
  '#66AA00',
  '#B82E2E',
  '#316395',
  '#994499',
  '#22AA99',
  '#AAAA11',
  '#6633CC',
  '#E67300',
  '#8B0707',
  '#329262',
  '#5574A6',
  '#3B3EAC',
];

export default {
  name: 'rule-base-match-widget',
  components: {
    GChart,
  },
  props: {
    criteria: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      pieChartOptions: {
        height: 280,
        chartArea: {
          top: 30,
          bottom: 30,
          width: '100%',
        },
        title: 'Rule set',
        legend: {
          position: 'labeled',
          alignment: 'center',
          textStyle: {
            fontSize: 14,
          },
        },
        pieSliceText: 'none',
        slices: {},
      },
      chartEvents: {
        click: this.onChartClick,
        ready: () => {
          if (document.querySelectorAll('#rulebase-chart text')[1]) {
            if (document.querySelectorAll('#rulebase-chart text')[1].innerHTML === 'No data') {
              document.querySelectorAll('#rulebase-chart text')[1].style.opacity = '0.5';
            }
          }
        }
      },
      focusId: null,
    };
  },
  watch: {
    criteria: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      loadRuleBaseMatchData: 'dashboard/loadRuleBaseMatchData',
    }),
    async init() {
      this.focusId = null;
      await this.loadRuleBaseMatchData({
        criteria: this.criteria,
      });
    },
    onChartClick(e) {
      if (this.focusId) {
        if (e.targetID.indexOf('chart') > -1) {
          this.focusId = null;
        }
      } else {
        // Match extract targetID to a modelID
        let sliceIndex = -1;
        if (e.targetID.indexOf('slice#') > -1) {
          sliceIndex = e.targetID.split('slice#').pop();
          // console.log('SLICE', sliceIndex);
        } else if (e.targetID.indexOf('legendentry#') > -1) {
          sliceIndex = e.targetID.split('legendentry#').pop();
          // console.log('SLICE', sliceIndex);
        }
        if (sliceIndex > -1) {
          const targetObj = this.ruleBaseStat[sliceIndex];
          this.focusId = targetObj.id;
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      ruleBaseStat: 'dashboard/ruleBaseStat',
    }),
    rulebaseMatchPieData() {
      const finalData = [];
      const slices = [];
      if (this.ruleBaseStat) {
        for (let i = 0; i < this.ruleBaseStat.length; i += 1) {
          const ruleSetData = this.ruleBaseStat[i];
          const color = ChartColor[i];
          let totalCount = 0;
          if (this.focusId) {
            if (ruleSetData.id === this.focusId) {
              if (ruleSetData.ruleList && ruleSetData.ruleList.length > 0) {
                totalCount = ruleSetData.ruleList
                  .map((obj) => obj.messageCount)
                  .reduce((a, c) => a + c);
              }
              finalData.push([
                ruleSetData.name,
                totalCount,
              ]);
              slices.push({ color });
            }
          } else {
            if (ruleSetData.ruleList && ruleSetData.ruleList.length > 0) {
              totalCount = ruleSetData.ruleList
                .map((obj) => obj.messageCount)
                .reduce((a, c) => a + c);
            }
            finalData.push([
              ruleSetData.name,
              totalCount,
            ]);
            slices.push({ color });
          }
        }
      } else {
        finalData.push([
          'No data', 1,
        ]);
      }
      finalData.unshift(['RuleSet', 'Total']);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.pieChartOptions.slices = slices;
      // TODO inevitable option
      return finalData;
    },
    preSeriesData() {
      let finalData = [];
      if (this.ruleBaseStat) {
        for (let i = 0; i < this.ruleBaseStat.length; i += 1) {
          const ruleSetData = this.ruleBaseStat[i];
          const color = ChartColor[i];
          if (this.focusId) {
            // Only push focus ID set
            if (ruleSetData.id === this.focusId) {
              finalData = ruleSetData.ruleList.map((obj) => ({
                count: obj.messageCount,
                name: obj.name,
                color,
              }));
              break;
            }
          } else {
            for (let j = 0; j < ruleSetData.ruleList.length; j += 1) {
              const obj = ruleSetData.ruleList[j];
              finalData.push({
                count: obj.messageCount,
                name: obj.name,
                color,
              });
            }
          }
        }
      }
      finalData.sort((a, b) => b.count - a.count);
      return finalData;
    },
    seriesData() {
      let finalData = [];
      if (this.preSeriesData) {
        finalData = this.preSeriesData.map((obj) => obj.count);
      }
      return [{
        name: 'จำนวนข้อความ',
        data: finalData,
      }];
    },
    seriesHeight() {
      let calHeight = 500;
      if (this.preSeriesData && this.preSeriesData.length > 0) {
        calHeight = Math.max(this.preSeriesData.length * 50, 500);
      }
      // console.log(calHeight);
      return `${calHeight}px`;
    },
    seriesOptions() {
      if (this.preSeriesData) {
        const categories = this.preSeriesData.map((obj) => obj.name);
        const colors = this.preSeriesData.map((obj) => obj.color);
        const height = this.seriesHeight;
        // console.log('he', height);
        return {
          plotOptions: {
            bar: {
              horizontal: true,
              distributed: true,
              dataLabels: {
                position: 'top',
                maxItems: 100,
                hideOverflowingLabels: true,
                orientation: 'horizontal',
              },
            },
          },
          legend: {
            show: false,
          },
          grid: {
            show: true,
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          colors,
          stroke: {
            show: true,
            width: 2,
            colors: ['#fff'],
          },
          xaxis: {
            categories,
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '14px',
              },
            },
          },
          chart: {
            height,
            id: 'rulebase-match',
          },
        };
      }
      return {};
    },
  },
};
</script>
<style lang="scss" scoped>
  .rulebase-match-widget {
    .padding-title-left {
      padding-left: 72px;
      font-size: 12.5px;
      font-weight: bold;
      color: #000;
    }
    .float-btn {
      position: absolute;
      top: -1px;
      left: 0;
    }
  }
</style>
